<template>
  <transition name="z-fade-in-linear">
    <div
      v-if="visible"
      :class="[ns.b(), ns.is('error', error)]"
    >
      <template v-if="error">
        <z-icon :size="40" color="var(--z-color-danger)">
          <CircleClose />
        </z-icon>
        <div :class="ns.e('text')">{{ t('z.table.loadError') }}</div>
        <div :class="ns.e('desc')">{{ errorMessage || t('z.table.loadErrorDetail') }}</div>
        <div :class="ns.e('actions')">
          <z-button @click="handleCancel">{{ t('z.table.loadCancel') }}</z-button>
          <z-button type="primary" :loading="loading" @click="handleReload">
            {{ t('z.table.loadRetry') }}
          </z-button>
        </div>
      </template>
      <template v-else>
        <span :class="ns.e('spinner')" />
        <div :class="ns.e('text')">{{ t('z.table.loadingText') }}</div>
      </template>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useLocale, useNamespace } from '@zoryn/hooks'
import ZButton from '@zoryn/components/button'
import ZIcon from '@zoryn/components/icon'
import { CircleClose } from '@zoryn/icons'
import type { DataGridTree } from '../types'

const ns = useNamespace('grid-loading')
const { t } = useLocale()
const $grid = inject('$grid') as DataGridTree

defineProps<{
  visible?: boolean
  loading?: boolean
  error?: boolean
  errorMessage?: string
}>()

const handleCancel = () => {
  $grid.reactData.loadError = false
  $grid.reactData.loadErrorMsg = ''
}

const handleReload = () => {
  $grid.reactData.loadError = false
  $grid.reactData.loadErrorMsg = ''
  void $grid.queryByExamplePage()
}
</script>
